module.exports = __webpack_public_path__ + "img/echo.e01948c9.png";